import axios from 'axios';
import globals from "../config/appconfig";
import Utils from "../utils/Utils";

export default class AssistentiService {

    static urlAssistenti = globals["app-url-backend-assistenti"] +"/assistenti"
    static urlExportFile = globals["app-url-backend-assistenti"] +"/export"
    static urlUploadFile = globals["app-url-backend-assistenti"] +"/assistenti/documenti"


    static getAssistente(params) {
        return axios.get(this.urlAssistenti + Utils.addQueryParamsToRequestUrl(params))
    }

    static getAssistenteComuneHome(params) {
        return axios.get(this.urlAssistenti + "/getAssistentiComune" + Utils.addQueryParamsToRequestUrl(params))
    }

    static inserisciAssistente(json) {
        return axios.post(this.urlAssistenti, json)
    }

    static modificaAssistente(id, json) {
        return axios.put(this.urlAssistenti+ "/"+id, json)
    }

    static getExportFile(params) {
        return axios.get(this.urlExportFile + Utils.addQueryParamsToRequestUrl(params))
    }

    static getExportFileHome(params) {
        return axios.get(this.urlExportFile + "/home" + Utils.addQueryParamsToRequestUrl(params))
    }

    static uploadFile(json) {
        return axios.post(this.urlUploadFile, json)
    }

    static modificaUploadFile(id, json) {
        return axios.put(this.urlUploadFile+ "/"+id, json)
    }

    static getFile(params) {
        return axios.get(this.urlUploadFile + Utils.addQueryParamsToRequestUrl(params))
    }


}
